/**
 * Created by Omar Padilla on 3/01/2017.
 */
import { Headers, Http, RequestOptions, ResponseContentType } from '@angular/http';

import { constant } from '../../../app.constants';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environments/environment';

export class ParentService {
  localVersion = environment.version;

  /**
   * Description:
   * @param {Http} http
   * @param router
   */
  public verifyToken(http: Http, router) {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Version': this.localVersion
    });
    const options = new RequestOptions({headers: headers});
    if (JSON.parse(localStorage.getItem('currentUser')) === null) {
      router.navigate(['/login']);
    } else {
      const user = JSON.parse(localStorage.getItem('currentUser'));
      const token = user ? user.token : '';
      http.get(constant.URL_VERIFY_TOKEN + token, options).subscribe(
        data => {
          if (data.json() === null) {
            localStorage.removeItem('currentUser');
            router.navigate(['/login']);
          }
        },
        () => {
          alert('Missed Connections');
        }
      );
    }
  }

  /**
   * Description:
   * @returns {RequestOptions}
   */
  getHeader() {

    if (JSON.parse(localStorage.getItem('currentUser')) !== null) {
      const user = JSON.parse(localStorage.getItem('currentUser'));
      const token = user ? user.token : '';
      const headers = new Headers({
        'Authorization': 'Session ' + token,
        'Version': this.localVersion
      });
      return new RequestOptions({headers: headers});
    }
  }

  /**
   * Description: return headers to download files
   * @returns {RequestOptions}
   */
  getFileHeaders() {
    if (JSON.parse(localStorage.getItem('currentUser')) !== null) {
      const user = JSON.parse(localStorage.getItem('currentUser'));
      const token = user ? user.token : '';
      const headers = new Headers(
        {
          'Authorization': 'Session ' + token,
          'Content-Type': 'application/json',
          'responseType': ResponseContentType.Blob,
          'Version': this.localVersion
        });
      return new RequestOptions({
        headers: headers,
        // tslint:disable-next-line:no-bitwise
        responseType: ResponseContentType.Blob | ResponseContentType.Json
      });
    }
  }

  /**
   * Description
   * @param v
   * @returns {RequestOptions}
   */
  getHeaderByVersion(v) {

    if (JSON.parse(localStorage.getItem('currentUser')) !== null) {
      const user = JSON.parse(localStorage.getItem('currentUser'));
      const token = user ? user.token : '';
      const headers = new Headers({'Authorization': 'Session ' + token, 'api-version': v});
      return new RequestOptions({headers: headers});
    }

  }

  /**
   * Description:
   * @returns {RequestOptions}
   */
  headerFile() {
    const headers = new Headers({
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json',
      'Version': this.localVersion
    });
    return new RequestOptions({headers: headers});
  }

  /**
   * Description:
   * @returns {RequestOptions}
   */
  singleHeader() {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Version': this.localVersion
    });
    return new RequestOptions({headers: headers});
  }

  /**
   * Description:
   * @returns {RequestOptions}
   */
  headerPost() {
    const user = JSON.parse(localStorage.getItem('currentUser'));
    const token = user ? user.token : '';
    const headers = new Headers({
      'Authorization': 'Session ' + token,
      'Content-Type': 'application/json',
      'Version': this.localVersion
    });
    return new RequestOptions({headers: headers});
  }

  /**
   * Description:
   * @returns {RequestOptions}
   */
  headerSinglePost() {
    const headers = new Headers({
      'Authorization': 'application/json',
      'Content-Type': 'application/json',
      'Version': this.localVersion
    });
    return new RequestOptions({headers: headers});
  }

  /**
   * Description:
   * @returns {RequestOptions}
   */
  headerDownloadPut() {
    const user = JSON.parse(localStorage.getItem('currentUser'));
    const token = user ? user.token : '';
    const headers = new Headers({
      'Authorization': 'Session ' + token,
      'Content-Type': 'application/json',
      'Accept': 'application/zip',
      'Version': this.localVersion
    });
    return new RequestOptions({headers: headers});
  }

  validate401Error(error, route) {
    // TODO This code is deprecated
    if (error.status === 401) {
      alert(error.json().message);
      route.navigate(['/login']);
      return Observable.throw(error.json());
    } else {
      return Observable.throw(error.json());
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/ParentClass/ParentService.ts